module.exports = __webpack_public_path__ + "media/images/pages/commercial/pocstock-cebrity-tzi-ma-37482b9807f1ed83366dd85fd57fab9f.png";